export default "/images/308212c9aed7c55c76bd5f6c0145cc77.jpg";